<template>
	<v-chip-group column active-class="secondary darken-5">
		<v-chip v-for="(game, i) in muayThai.gameThemes" :key="i" color="primary darken-4">
			{{ game }}
		</v-chip>
	</v-chip-group>
</template>

<script>
export default {
	data() {
		return {}
	},
	computed: {
		muayThai() {
			return this.$store.getters["Casino/muayThai"]
		},
	},
}
</script>

<style></style>
